/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LoginModule
 */

import { Component } from '@angular/core';

import './login-container.component.less';

/**
 * @description
 *      Login-container component.
 *          - Background
 *          - App title
 *          - will project whatever component passed.
 * @author Aravindh Nagarajan
 */
@Component({
    selector: 'login-container',
    templateUrl: './login-container.component.html',
})
export class LoginContainerComponent {}
